import styled from 'styled-components';
import { Color, FontFamily, FontSize, FontWeight, LineHeight, Spacing, UnitSize } from '@pushwoosh/kit-constants';
export const FieldBoxContainer = styled.div.withConfig({
  displayName: "FieldBoxContainer",
  componentId: "sc-1mvg87-0"
})(["width:100%;opacity:", ";pointer-events:", ";"], ({
  isLoading
}) => isLoading ? '.5' : '1', ({
  isLoading
}) => isLoading ? 'none' : 'auto');
export const FieldBoxHeader = styled.div.withConfig({
  displayName: "FieldBoxHeader",
  componentId: "sc-1mvg87-1"
})(["display:flex;align-items:center;min-height:calc(", " * ", ");margin:0 0 ", ";font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";text-transform:uppercase;"], FontSize.HEADING5, LineHeight.REGULAR, Spacing.S1, FontFamily.MAIN, FontSize.HEADING5, FontWeight.MEDIUM, LineHeight.REGULAR, Color.MAIN);
export const FieldBoxOptionalText = styled.span.withConfig({
  displayName: "FieldBoxOptionalText",
  componentId: "sc-1mvg87-2"
})(["color:", ";"], Color.PHANTOM);
export const FieldBoxContent = styled.div.withConfig({
  displayName: "FieldBoxContent",
  componentId: "sc-1mvg87-3"
})(["min-height:", ";"], UnitSize.FIELD_HEIGHT);
export const FieldBoxFooter = styled.div.withConfig({
  displayName: "FieldBoxFooter",
  componentId: "sc-1mvg87-4"
})(["padding:", " 0 0;color:", ";font-family:", ";font-size:", ";font-weight:", ";line-height:", ";"], Spacing.S1, Color.LOCKED, FontFamily.MAIN, FontSize.SMALL, FontWeight.REGULAR, LineHeight.SMALL);
FieldBoxContainer.displayName = 'FieldBoxContainer';
FieldBoxHeader.displayName = 'FieldBoxHeader';
FieldBoxContent.displayName = 'FieldBoxContent';
FieldBoxFooter.displayName = 'FieldBoxFooter';